import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Panel} from "../../models/formio/panel";
import {IFormHistory} from "../../models/form-history-interface";
import {BaseForm} from "../../models/base-form";
import Helpers from "../../utils/helpers";

@Injectable()
export class PaymentFormControllerService implements IFormHistory {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getFormPayments(serviceId: string, roleType: string): Observable<Panel> {
    let url = this.baseUrl + "service/" + serviceId + "/formio/payments";
    if (roleType) {
      url += `?roleType=${roleType}`;
    }
    return this.http.get(url) as Observable<Panel>;
  }

  public getFormPaymentProviders(serviceId: string): Observable<Panel> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/formio/payment_providers") as Observable<Panel>;
  }

  /**
   * The instance's payment providers for authoring screens, each with the capabilities its adapter
   * declares in ds-backend. Distinct from getFormPaymentProviders above, which returns the
   * applicant payment form's formio panel and carries no capability information.
   */
  public getPaymentProviders(): Observable<any[]> {
    return this.http.get(this.baseUrl + "payment_providers") as Observable<any[]>;
  }

  public getHistoryPage(serviceId: string, page: number): Observable<any[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/payment/pagedhistory?pageNo=" + page + "&pageSize=12") as Observable<any[]>;
  }

  public getPaymentForm(serviceId: string, reusable: boolean): Observable<BaseForm> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/payment?reusable=" + reusable) as Observable<BaseForm>;
  }

  public createPaymentForm(serviceId: string, form: BaseForm): Observable<BaseForm> {
    Helpers.stripCKEditorParagraphWrapper(form.formSchema);
    Helpers.trimRecursiveObj(form);
    const body = JSON.stringify(form);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/payment", body) as Observable<BaseForm>;
  }

  public savePaymentForm(form: BaseForm) {
    Helpers.stripCKEditorParagraphWrapper(form.formSchema);
    Helpers.trimRecursiveObj(form);
    const body = JSON.stringify(form);
    return this.http.put(this.baseUrl + "payment/" + form.id, body, {responseType: "text"});
  }

  public activatePaymentForm(formId: string, active: boolean) {
    return this.http.put(this.baseUrl + "payment/activate/" + formId + "/" + active, null, {responseType: "text"});
  }

  public getHistory(serviceId: string): Observable<any[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/payment/history") as Observable<any[]>;
  }

  // Get form schema for preview only (GET request)
  public getFormSchemaForRevision(serviceId: string, revisionNumber: string): Observable<any> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/payment/history/" + revisionNumber + "/schema") as Observable<any>;
  }

  // Revert form to a specific revision (PUT request - triggers cleanup of orphaned relations)
  public revertFormToRevision(serviceId: string, revisionNumber: string): Observable<any> {
    return this.http.put(this.baseUrl + "service/" + serviceId + "/payment/history/" + revisionNumber, null, {responseType: "text"}) as Observable<any>;
  }

}
